import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2>The page you are looking For is Not Available </h2>
            <img src='https://colorlib.com/cdn-cgi/image/quality=80,format=auto,onerror=redirect,metadata=none/wp/wp-content/uploads/sites/2/404-error-page-templates.jpg' width="50%" height="50%" alt=''></img>
        </div>
    );
};

export default NotFound;